export default __webpack_public_path__ + "1499f61662a47060fa16058d04bd1ce7.woff2";